<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <inbox-header :title="title" :path="path" :text="text" :text1="text1" />

      <div class="row">
        <div class="col-md-12">
          <table-page-size-changer @page-size-changed="handlePageSizeChanged" defaultPageSize="10" />
          <input
            v-model="search"
            type="text"
            class="form-control server-search-input"
            placeholder="Search..."
            @input="handleSearchChange"
          />
          <ExportBtns
            :parent="this"
            :columns="columns"
            :data="filteredData"
            fileName="my-projects"
            :server-side="true"
            :server-export="handleServerExport"
            :hide-search="true"
          />

          <div class="table-responsive table-newdatatable">
            <a-table
              :pagination="tablePagination"
              @change="handlePageTableChange"
              :loading="loading"
              class="stripped table-hover"
              :columns="columns"
              :data-source="filteredData"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'id'">
                  {{ getSerialNumber(record) }}
                </template>
                <template v-if="column.key === 'action'">
                  <div class="table-actions d-flex justify-content-center">
                    <!-- <a
                      class="delete-table me-2"
                      href="javascript:;"
                      @click="selectedAssetDetails(record.id)"
                      data-bs-toggle="modal"
                      data-bs-target="#asset_details_modal"
                    > -->
                    <router-link :to="`/my-team/project/${record.id}`">
                      <img
                        :src="require(`@/assets/img/icons/eye.svg`)"
                        alt="Eye Icon"
                      />
                    </router-link>
                    <!-- </a> -->
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- Projects Tab -->
  <!-- /Projects Tab -->
</template>
<script>
// import ProjectCard from "./ProjectsList.vue";

import MyProjectService from "@/services/MyProjectService";
import ExportBtns from "@/components/ExportBtns.vue";
import { mapActions, mapState } from "vuex";

import debounceMixin from "@/mixins/debounce";

const columns = [
  {
    title: "Id ",
    dataIndex: "id",

    sorter: {
      compare: (a, b) => {
        a = a.id;
        b = b.id;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Code No",
    dataIndex: "project_code",
    sorter: {
      compare: (a, b) => {
        a = a.project_code.toLowerCase();
        b = b.project_code.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Project Name",
    dataIndex: "project_name",
    sorter: {
      compare: (a, b) => {
        a = a.project_name.toLowerCase();
        b = b.project_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
    sorter: {
      compare: (a, b) => {
        a = a.start_date.toLowerCase();
        b = b.start_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Deadline",
    dataIndex: "end_date",
    sorter: {
      compare: (a, b) => {
        a = a.end_date.toLowerCase();
        b = b.end_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Priority",
    dataIndex: "priority",
    sorter: {
      compare: (a, b) => {
        a = a.priority.toLowerCase();
        b = b.priority.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "View Tasks",
    key: "action",
    sorter: true,
    class: "text-end",
  },
];

export default {
  mixins: [debounceMixin],
  components: {
    // ProjectCard,
    ExportBtns,
  },
  data() {
    return {
      search: "",
      debouncedFetch: null,
      title: "Projects",
      path: "ESS",
      text: "Projects",
      text1: "Add New",
      columns,
      data: [],
      filteredData: [],
      selectedAsset: {},
      assetDetails: {},
      loading: false,
    };
  },
  methods: {
    ...mapActions("theme", ["updatePagination"]),
    async handlePageTableChange(pagination) {
      const params = {
        page: pagination.current,
        per_page: pagination.pageSize,
      };
      this.updatePagination({
        current: pagination.current,
        pageSize: pagination.pageSize,
      });

      await this.fetchProjects(params);
    },
    handlePageSizeChanged(newPageSize) {
      if (newPageSize) {
        this.handlePageTableChange({
          ...this.tablePagination,
          current: 1,
          pageSize: newPageSize,
        });
      }
    },
    getSerialNumber(record) {
      const index = this.filteredData?.findIndex(
        (item) => item.id === record.id
      );
      return index + 1;
    },
    // Server-side export: backend exports the full list, only the type is sent.
    async handleServerExport(type) {
      return MyProjectService.exportList(type);
    },
    handleSearchChange() {
      if (!this.debouncedFetch) {
        this.debouncedFetch = this.debounce(this.applySearch, 350);
      }
      this.debouncedFetch();
    },
    applySearch() {
      this.updatePagination({ ...this.tablePagination, current: 1 });
      this.fetchProjects({ page: 1, per_page: this.tablePagination?.pageSize });
    },
    async fetchProjects(params = {}) {
      const search = this.search?.trim();
      try {
        this.loading = true;
        const page = params.page || this.tablePagination?.current || 1;
        const per_page =
          params.per_page || this.tablePagination?.pageSize || 10;
        const response = await MyProjectService.getProjects({
          page,
          per_page,
          ...(search ? { search } : {}),
        });
        const rows = response.data?.data || [];
        this.data = rows;
        this.filteredData = rows;
        this.updatePagination({
          current: page,
          pageSize: per_page,
          total: response.data?.pagination?.total_records ?? rows.length,
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("error fetching projects", error);
      }
    },
    //   selectedAssetDetails(id) {
    //     this.selectedAsset = this.data.find((asset) => asset.id === id);
    //     this.assetDetails = this.selectedAsset.asset_detail;
    //   },
  },
  computed: {
    ...mapState("theme", ["tablePagination"]),
  },
  created() {
    this.fetchProjects();
  },
};
</script>

<style scoped>
.server-search-input {
  max-width: 300px;
  margin-bottom: 10px;
}
</style>
